<div
  class="wrapper"
  [matTooltip]="disabled() ? disabledExplanation() : undefined">
  @for (option of options(); track option; let last = $last) {
    <div
      role="radio"
      [class]="'option-' + variant()"
      [class.disabled]="disabled()"
      [class.selected]="option.value === value"
      [attr.aria-selected]="option.value === value"
      (click)="selectOption(option.value)">
      <ng-container *ngTemplateOutlet="option.template"></ng-container>
    </div>
  }
</div>
